import { headerStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryHeader";
import { css } from "styled-components";

headerStyles.invoiceCountGridItem = {
    width: 11,
    css:css`
    display: flex;
align-items: center;
    `,
    style: { fontWeight: 600 },
}